export default __webpack_public_path__ + "static/media/monnal-t60-ventilator.91c87437.jpg";